/* ════════════════════════════════════════════
   DESIGN TOKENS
   ════════════════════════════════════════════ */

export const C_ORIGINAL = {
  black: "#050810",
  bg: "#080c18",
  raised: "#0c1124",
  surface: "#111730",
  surfaceHover: "#151d3a",
  card: "#0e1428",
  cardHover: "#121a34",
  border: "#1a2340",
  borderHover: "#253060",
  borderSubtle: "#141c35",
  accent: "#4f6af0",
  accentBright: "#6b82ff",
  accentDim: "#3a50c0",
  accentGhost: "#4f6af012",
  accentWash: "#4f6af01a",
  purple: "#8b6cf0",
  purpleWash: "#8b6cf018",
  purpleBorder: "#8b6cf030",
  teal: "#14b8a6",
  tealWash: "#14b8a618",
  green: "#22c55e",
  greenWash: "#22c55e18",
  greenBorder: "#22c55e35",
  amber: "#f59e0b",
  amberWash: "#f59e0b18",
  amberBorder: "#f59e0b35",
  red: "#ef4444",
  redWash: "#ef444418",
  redBorder: "#ef444435",
  text: "#e4e9f2",
  textSoft: "#9aa3be",
  textMuted: "#5e6a88",
  white: "#fff",
};

export const C_NEW = {
  black: "#050412",
  bg: "#080720",
  raised: "#0e0c28",
  surface: "#131132",
  surfaceHover: "#191738",
  card: "#100e26",
  cardHover: "#16142e",
  border: "#1e1b40",
  borderHover: "#2e2a5c",
  borderSubtle: "#151230",
  accent: "#7c6ff7",
  accentBright: "#a09bff",
  accentDim: "#5548d4",
  accentGhost: "#7c6ff712",
  accentWash: "#7c6ff71a",
  purple: "#a78bfa",
  purpleWash: "#a78bfa18",
  purpleBorder: "#a78bfa30",
  teal: "#2dd4bf",
  tealWash: "#2dd4bf18",
  green: "#34d399",
  greenWash: "#34d39918",
  greenBorder: "#34d39935",
  amber: "#fbbf24",
  amberWash: "#fbbf2418",
  amberBorder: "#fbbf2435",
  red: "#f87171",
  redWash: "#f8717118",
  redBorder: "#f8717135",
  text: "#edeaf8",
  textSoft: "#a29ec0",
  textMuted: "#63608a",
  white: "#fff",
};

export const C = C_NEW;
